import '../style/date-popper.scss'
export default {
  functional: true,
  render(h, context) {
    const attrs = {
      props: {
        placement: 'top',
        trigger: 'hover',
        'popperClass': 'kye-date-picker_date-popper-wrap',
        ...(context.props.popoverProps || {})
      },
      on: {
        ...(context.props.popoverEvent || {})
      },
      ref: 'popoverRef'
    }
    return (
      <el-popover {...attrs}>
        <div class="content">{context.props.content}</div>
      </el-popover>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker3/src/basic/popover.js